// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Beat Loader component CSS style */

/* Can't easily be written in JS and parsed to CSS */

@-webkit-keyframes beatloader {
  /* Chrome, Safari, Opera */
  50% {
    transform: scale(0.75);
    opacity: 0.2;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes beatloader {
  /* Standard syntax */
  50% {
    transform: scale(0.75);
    opacity: 0.2;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./css/beat_loader.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,oDAAoD;;AAEpD;EACE,0BAA0B;EAC1B;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":["/* Beat Loader component CSS style */\n\n/* Can't easily be written in JS and parsed to CSS */\n\n@-webkit-keyframes beatloader {\n  /* Chrome, Safari, Opera */\n  50% {\n    transform: scale(0.75);\n    opacity: 0.2;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes beatloader {\n  /* Standard syntax */\n  50% {\n    transform: scale(0.75);\n    opacity: 0.2;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
